import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(request: Request): Promise<Optional<ResponseData>> {
	const url = `${SERVICEBASEURL.BACKEND}/Nutrient/Search`;
	return axios.post(url, request).toOptionalMapped((x) => x.data);
}

export interface Request {
	pageIndex?: number | null;
	pageSize?: number | null;
	searchTerm?: string | null;
	showOnlyDeleted?: boolean | null;
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = {
	data: ResponseNutrient[];
	pageIndex: number;
	pageSize: number;
	totalCount: number;
	totalPages: number;
	hasPreviousPage: boolean;
	hasNextPage: boolean;
};

export type ResponseNutrient = {
	id: string;
	name: string;
	shortName: string;
	unit: string;
	isMacroNutrient: boolean;
	nutrientCategory: string;
};
